<template>
    <day-overview selected-date="2020-12-30"></day-overview>
</template>

<script>
import dayOverview from "@/components/dayOverview";
export default {
  components: { dayOverview },
}
</script>